export default __webpack_public_path__ + "static/advocatenkantoor-d2be25619188c0098a6e030363d88271.jpg";